import { Link } from "react-router-dom";
import { formatPrice, productImage } from "../../api/shopApi";

export default function ShopProductCard({ item }) {
  if (!item) return null;
  return (
    <Link
      to={`/shop/product/${item.slug}`}
      className="bg-white rounded-2xl border border-pink-100 overflow-hidden shadow-sm hover:shadow-md transition block"
    >
      <div className="aspect-square bg-rose-50 overflow-hidden">
        <img
          src={productImage(item.main_image)}
          alt={item.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-3 space-y-1.5">
        <h3 className="font-semibold text-gray-800 text-sm line-clamp-2">{item.name}</h3>
        {item.subtitle ? (
          <p className="text-xs text-gray-500 line-clamp-1">{item.subtitle}</p>
        ) : null}
        <div className="flex items-baseline gap-2">
          <span className="text-rose-600 font-bold">{formatPrice(item.price)}</span>
          {item.compare_at_price ? (
            <span className="text-xs text-gray-400 line-through">
              {formatPrice(item.compare_at_price)}
            </span>
          ) : null}
        </div>
        <span className="inline-block text-xs text-pink-600 mt-1">查看详情 →</span>
      </div>
    </Link>
  );
}
